(() => {
  const sections = document.querySelectorAll('.mt-training-scenarios-slider[data-section-id]');

  if (!sections.length) return;

  const formatCounter = (value) => String(value).padStart(2, '0');
  const playVideo = (video) => {
    video.muted = true;
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  };

  const pauseVideo = (video) => {
    video.pause();
    video.currentTime = 0;
  };

  const syncSlideVideos = (swiper) => {
    swiper.slides.forEach((slide, index) => {
      const isActive = index === swiper.activeIndex;
      const videos = slide.querySelectorAll('video');

      videos.forEach((video) => {
        if (isActive) {
          playVideo(video);
        } else {
          pauseVideo(video);
        }
      });
    });
  };

  const scheduleVideoSync = (swiper) => {
    if (swiper.__videoSyncTimer) {
      window.clearTimeout(swiper.__videoSyncTimer);
    }

    window.requestAnimationFrame(() => {
      syncSlideVideos(swiper);
    });

    swiper.__videoSyncTimer = window.setTimeout(() => {
      syncSlideVideos(swiper);
    }, (swiper.params.speed || 0) + 80);
  };

  const initSection = (section) => {
    const sliderRoot = section.querySelector('[data-slider-root]');
    if (!sliderRoot || typeof Swiper === 'undefined') return;
    const enableLoop = sliderRoot.dataset.loopEnabled === 'true';

    if (sliderRoot.swiper) {
      sliderRoot.swiper.destroy(true, true);
    }

    const prevButton = section.querySelector('[data-slider-prev]');
    const nextButton = section.querySelector('[data-slider-next]');
    const currentCounter = section.querySelector('[data-slider-current]');
    const progressFill = section.querySelector('[data-slider-progress-fill]');
    const progressItems = Array.from(section.querySelectorAll('[data-slider-index]'));
    const contentItems = Array.from(section.querySelectorAll('[data-content-index]'));

    const updateProgress = (swiper) => {
      const total = progressItems.length;
      if (!progressFill || total <= 0) return;

      const currentIndex = swiper.realIndex || 0;
      const ratio = (currentIndex + 1) / total;
      progressFill.style.width = `${ratio * 100}%`;
    };

    const updateUI = (swiper) => {
      const currentIndex = swiper.realIndex || 0;

      if (currentCounter) {
        currentCounter.textContent = formatCounter(currentIndex + 1);
      }

      updateProgress(swiper);

      progressItems.forEach((item, index) => {
        const isActive = index === currentIndex;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      contentItems.forEach((item, index) => {
        item.classList.toggle('is-active', index === currentIndex);
      });

      scheduleVideoSync(swiper);
    };

    const swiper = new Swiper(sliderRoot, {
      slidesPerView: 1,
      spaceBetween: 10,
      speed: 550,
      loop: enableLoop && progressItems.length > 1,
      simulateTouch: true,
      allowTouchMove: true,
      grabCursor: true,
      resistanceRatio: 0.85,
      observer: true,
      observeParents: true,
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton
      },
      on: {
        init() {
          updateUI(this);
        },
        progress() {
          updateProgress(this);
        },
        slideChange() {
          updateUI(this);
        },
        slideChangeTransitionEnd() {
          scheduleVideoSync(this);
        }
      }
    });

    progressItems.forEach((item) => {
      item.addEventListener('click', () => {
        const index = Number(item.dataset.sliderIndex);
        if (!Number.isNaN(index)) {
          if (swiper.params.loop) {
            swiper.slideToLoop(index);
          } else {
            swiper.slideTo(index);
          }
        }
      });
    });
  };

  sections.forEach((section) => {
    initSection(section);
  });
})();
